import createSimpleReducers from '../Shared/ducks/createSimpleReducers'

export default createSimpleReducers('Consent')
